
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  globalError: null, // 'offline' | 'server' | null
};

const appStatusSlice = createSlice({
  name: 'appStatus',
  initialState,
  reducers: {
    setGlobalError(state, action){
      state.globalError = action.payload; // Expected: 'offline', 'server', etc.
    },
    clearGlobalError(state){
      state.globalError = null;
    },
  },
});

export const { setGlobalError, clearGlobalError } = appStatusSlice.actions;

export default appStatusSlice;
